import React from "react";
import PropTypes from "prop-types";

import {Avatar, Box, Card, CardMedia} from "@mui/material";

import StarIcon from '@mui/icons-material/Star';


const CardLayout = (props) => {
    const {avatarColor, AvatarIcon = StarIcon, children} = props;

    return (
        <Card>
            <Box sx={{minHeight: 220, display: "flex", alignItems: "stretch"}}>
                <Box p={4}
                     justifyContent="center"
                     alignItems="center"
                     sx={{
                         display: {lg: 'flex', xs: 'none'},
                         borderRight: (theme) => `1.2px solid ${theme.palette.divider}`
                     }}>
                    <CardMedia>
                        <Avatar sx={{width: 80, height: 80, backgroundColor: avatarColor}}>
                            <AvatarIcon sx={{fontSize: "2.5rem", color: '#ffffff'}}/>
                        </Avatar>
                    </CardMedia>
                </Box>
                <Box sx={{p: 2, flexGrow: 1}}>
                    {children}
                </Box>
            </Box>
        </Card>
    );
};

CardLayout.propTypes = {
    avatarColor: PropTypes.string.isRequired,
    AvatarIcon: PropTypes.object,
    children: PropTypes.node.isRequired
};

export {CardLayout}